<template>
    <login></login>
</template>

<style scoped>

</style>

<script>

import Login from "@/components/Login";


export default {
    name: 'Signup',
    components: {
        Login
    },
    computed: {
        handleTitle() {
            if(this.$router.currentRoute.params.id) {
                return 'Register Prompt'
            }
            else {
                return 'Login'
            }
        }
    },
    props: {},
    data() {
        return {}
    },
    metaInfo() {
        return {
            title: 'Login - Sign Up | Pickafund',
            meta: [
                { name: 'description', content: 'Login or sign up for free to enjoy full access on Pickafund'},
                { property: 'og:title', content: this.$router.currentRoute.params.id ? "Why Register | Pickafund" : "Login - Sign Up | Pickafund"},
            ]
        }
    }
}
</script>


